module.exports = __webpack_public_path__ + "img/image9.8dc03726.png";